module.exports = __webpack_public_path__ + "static/media/waterbath-open.b1267168.svg";